import {
  ContextEyebrow,
  ContextSubtitle,
  PageContextRow,
} from '../../WorkspaceHeaderLayout.styles';

type Props = {
  eyebrow: string;
  sessionTitle?: string;
};

export const WorkspaceHeaderCompactContext: React.FC<Props> = ({
  eyebrow,
  sessionTitle,
}) => (
  <PageContextRow>
    <ContextEyebrow>{eyebrow}</ContextEyebrow>
    {sessionTitle && (
      <ContextSubtitle>{sessionTitle}</ContextSubtitle>
    )}
  </PageContextRow>
);
